import guid from './guid';
import isLocalStorageAvailable from './isLocalStorageAvailable';

function getDeviceId() {
    var curDeviceId, deviceIdKey = 'alan-device-id';
    const isStorageAvailable = isLocalStorageAvailable();

    curDeviceId = isStorageAvailable ? localStorage.getItem(deviceIdKey) : window.deviceId;

    if (!curDeviceId) {
        curDeviceId = guid();
        if (isStorageAvailable) {
            localStorage.setItem(deviceIdKey, curDeviceId);
        } else {
            window.deviceId = curDeviceId;
        }
    }
    return curDeviceId;

}

export default getDeviceId;
